export const sortBytranslation =
    (t: (s: string) => string) =>
    <T extends { translation_slug: string }>(curr: T, next: T) =>
        t(curr.translation_slug).toLowerCase().localeCompare(t(next.translation_slug).toLowerCase());
